/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type reconciliation_SubsidyOfficeChildRefDTO = {
    id: string;
    officeChildRef: string;
    /**
     * Source is manual (entered or picked by an operator) or name_exact
     * (learned by the statement import from a unique name match).
     */
    source: reconciliation_SubsidyOfficeChildRefDTO.source;
    subsidyOfficeId: string;
    subsidyOfficeName: string;
    updatedAt: string;
};
export namespace reconciliation_SubsidyOfficeChildRefDTO {
    /**
     * Source is manual (entered or picked by an operator) or name_exact
     * (learned by the statement import from a unique name match).
     */
    export enum source {
        MANUAL = 'manual',
        NAME_EXACT = 'name_exact',
    }
}

